module.exports = "@media (min-width: 1340px) {\n  .mapContainer {\n    max-width: 400px; } }\n\nagm-map {\n  height: 340px; }\n\n.font-black {\n  color: black; }\n\n.font-grey {\n  color: #9b9b9b; }\n\n.btn-smaller {\n  font-size: 15px; }\n\n::ng-deep .mat-stepper-horizontal-line {\n  margin: initial !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/alarm-zone/alarm-zone.component.scss
// module id = ./src/app/shared/components/alarm-zone/alarm-zone.component.scss
// module chunks = main